/* Milagron - Koleksiyon filtresinde eksiksiz ve secime gore daralan "Urun Turu" / "Marka" listesi.
 *
 * 1) Shopify'in kendi listesi buyuk koleksiyonlarda eksik donuyor. Bu dosya koleksiyondaki urunlerin
 *    tur/marka bilgisini Storefront API'den okuyup eksiksiz listeyi uretir.
 * 2) Liste secime gore daralir: tur secilince yalnizca o turde urunu olan markalar, marka secilince
 *    yalnizca o markada urunu olan turler gorunur. Beden/renk/fiyat vb. baska filtre aciksa, ayni
 *    sonuc Storefront API'den filtreli sekilde alinir. Boylece urunu olmayan secim sunulmaz.
 * 3) Yine de bos sonuc cikarsa son secim otomatik geri alinir ve kisa bir uyari gosterilir.
 * Kutular ayni isimle (filter.p.product_type / filter.p.vendor) form icinde kalir; temanin kendi
 * filtreleme (AJAX) mantigi aynen calisir. Veri tarayicida kisa sure saklanir.
 */
(function () {
  'use strict';
  if (window.__mxCompleteFilters) return;
  window.__mxCompleteFilters = true;

  /* Bu scripti tasiyan bos bolumu gizle */
  try {
    var cs = document.currentScript;
    var wrap = cs && cs.closest('[id^="section-id-"]');
    if (wrap) wrap.style.display = 'none';
  } catch (e) {}

  var API_VERSION = '2026-07';
  var TTL = 6 * 3600 * 1000;            /* onbellek en fazla 6 saat gecerli */
  var REFRESH_AFTER = 20 * 60 * 1000;   /* 20 dk'dan eskiyse arka planda yenile */
  var MAX_PRODUCTS = 6000;              /* bundan buyuk koleksiyonlarda dokunma */
  var PT = 'filter.p.product_type', PV = 'filter.p.vendor', AV = 'filter.v.availability';
  var SKIP_HANDLES = { vendors: 1, types: 1 };

  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]);
  if (SKIP_HANDLES[handle]) return;

  var token = null;
  try { token = JSON.parse(document.getElementById('shopify-features').textContent).accessToken; } catch (e) {}
  if (!token) return;

  var Q = 'query($h:String!,$a:String,$f:[ProductFilter!]){collection(handle:$h){products(first:250,after:$a,filters:$f){' +
          'pageInfo{hasNextPage endCursor}nodes{productType vendor availableForSale}}}}';

  var cacheKey = 'mxcf3:' + handle;
  var DATA = null;          /* {ts,total,pairs:[[tur,marka,adet,stoktaki_adet]]} */
  var ver = 0;              /* DATA her degistiginde artar */
  var loading = false;
  var tickHTML = '';
  var lastAction = null;    /* kullanicinin son filtre tiki (guvenlik agi icin) */
  var reverting = false;
  var toastTimer = null;
  var oracle = Object.create(null);   /* filtreli sorgu sonuclari */
  var inflight = { t: null, v: null };

  /* ---------- stil ---------- */
  var sty = document.createElement('style');
  sty.textContent = '.mx-cf-scroll{max-height:320px;overflow-y:auto;padding-right:6px}' +
    '.mx-cf-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);max-width:90vw;box-sizing:border-box;' +
    'background:#1b1b1b;color:#fff;padding:11px 18px;border-radius:6px;font-size:14px;line-height:1.4;z-index:2147483000;' +
    'box-shadow:0 4px 18px rgba(0,0,0,.25);text-align:center}' +
    '.filter-group.mx-cf-busy .toggle-target-container{opacity:.4;pointer-events:none;transition:opacity .15s}';
  document.head.appendChild(sty);

  /* ---------- yardimcilar ---------- */
  function slug(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9À-ɏ]+/gi, '-').replace(/^-+|-+$/g, '');
  }
  function pack(o) {
    var T = [], V = [], ti = Object.create(null), vi = Object.create(null), P = [];
    o.pairs.forEach(function (p) {
      if (!(p[0] in ti)) { ti[p[0]] = T.length; T.push(p[0]); }
      if (!(p[1] in vi)) { vi[p[1]] = V.length; V.push(p[1]); }
      P.push(ti[p[0]], vi[p[1]], p[2], p[3]);
    });
    return { ts: o.ts, total: o.total, T: T, V: V, P: P };
  }
  function unpack(c) {
    var pairs = [];
    for (var i = 0; i + 3 < c.P.length; i += 4) pairs.push([c.T[c.P[i]], c.V[c.P[i + 1]], c.P[i + 2], c.P[i + 3]]);
    return { ts: c.ts, total: c.total, pairs: pairs };
  }
  function readCache() {
    try {
      var s = localStorage.getItem(cacheKey);
      if (!s) return null;
      var c = JSON.parse(s);
      if (!c || !c.ts || !Array.isArray(c.P) || !Array.isArray(c.T) || !Array.isArray(c.V)) return null;
      if (Date.now() - c.ts > TTL) return null;
      return unpack(c);
    } catch (e) { return null; }
  }
  function writeCache(o) {
    var s;
    try { s = JSON.stringify(pack(o)); } catch (e) { return; }
    try { localStorage.setItem(cacheKey, s); return; } catch (e) {}
    try {   /* kota doldu: eski koleksiyon kayitlarini temizleyip bir kez daha dene */
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf('mxcf') === 0 && k !== cacheKey) localStorage.removeItem(k);
      }
      localStorage.setItem(cacheKey, s);
    } catch (e) {}
  }

  /* ---------- veri: koleksiyondaki (filtreli) urunleri cek, tur+marka ciftlerini say ---------- */
  function fetchPairs(filters, signal) {
    var map = Object.create(null), total = 0, after = null;
    function page() {
      return fetch('/api/' + API_VERSION + '/graphql.json', {
        method: 'POST',
        signal: signal,
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query: Q, variables: { h: handle, a: after, f: (filters && filters.length) ? filters : null } })
      }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      }).then(function (j) {
        var c = j && j.data && j.data.collection;
        if (!c) throw new Error('no collection');
        var p = c.products;
        p.nodes.forEach(function (x) {
          total++;
          var k = (x.productType || '') + '\u0001' + (x.vendor || '');
          var e = map[k] || (map[k] = [0, 0]);
          e[0]++;
          if (x.availableForSale) e[1]++;
        });
        if (p.pageInfo.hasNextPage) {
          if (total >= MAX_PRODUCTS) return { partial: true };
          after = p.pageInfo.endCursor;
          return page();
        }
        return {};
      });
    }
    return page().then(function (res) {
      var pairs = [];
      for (var k in map) { var a = k.split('\u0001'); pairs.push([a[0], a[1], map[k][0], map[k][1]]); }
      return { ts: Date.now(), total: total, partial: !!res.partial, pairs: pairs };
    });
  }

  var disabled = false;
  function load() {
    if (loading) return;
    loading = true;
    fetchPairs(null).then(function (o) {
      loading = false;
      if (o.partial) { disabled = true; return; }   /* tam liste elde edilemedi: mevcut filtreye dokunma */
      DATA = o; ver++; writeCache(o); apply();
    }).catch(function () { loading = false; });
  }

  /* ---------- filtre durumu (formdaki isaretli kutulardan) ---------- */
  function readState() {
    var form = document.getElementById('CollectionFilterForm');
    if (!form) return null;
    var s = { types: [], vendors: [], avail: false, other: [] };
    var els = form.querySelectorAll('input');
    for (var k = 0; k < els.length; k++) {
      var i = els[k], n = i.name, ty = i.type;
      if (!n || n.indexOf('filter.') !== 0) continue;
      if (ty === 'checkbox' || ty === 'radio') { if (!i.checked || i.value === '') continue; }
      else if (ty === 'text' || ty === 'number' || ty === 'search' || ty === 'tel') { if (!i.value) continue; }
      else continue;
      if (n === PT) s.types.push(i.value);
      else if (n === PV) s.vendors.push(i.value);
      else if (n === AV && i.value === '1') s.avail = true;
      else s.other.push([n, i.value]);
    }
    return s;
  }
  function stateKey(s) {
    return JSON.stringify([s.types.slice().sort(), s.vendors.slice().sort(), s.avail, s.other.slice().sort()]);
  }
  function labelFor(name) {
    var inp = document.querySelector('#CollectionFilterForm input[name="' + name + '"]');
    var grp = inp && inp.closest('.filter-group');
    var h = grp && grp.querySelector('.filter-group__heading__text');
    var t = h && h.textContent.replace(/\s+/g, ' ').trim();
    return t || name.replace(/^filter\.v\.option\./, '');
  }
  function optName(n) {
    var raw = n.replace(/^filter\.v\.option\./, '');
    try { raw = decodeURIComponent(raw); } catch (e) {}
    return raw || labelFor(n);
  }
  /* Sayfadaki filtreleri Storefront API filtrelerine cevir (kendi grubu haric). Cevrilemezse null. */
  function toFilters(s, skip) {
    var f = [], price = null, i, o, n, v;
    if (skip !== 't') for (i = 0; i < s.types.length; i++) f.push({ productType: s.types[i] });
    if (skip !== 'v') for (i = 0; i < s.vendors.length; i++) f.push({ productVendor: s.vendors[i] });
    if (s.avail) f.push({ available: true });
    for (i = 0; i < s.other.length; i++) {
      n = s.other[i][0]; v = s.other[i][1];
      if (n === 'filter.v.price.gte' || n === 'filter.v.price.lte') {
        var num = parseFloat(String(v).replace(',', '.'));
        if (isNaN(num)) return null;
        price = price || {};
        if (n === 'filter.v.price.gte') price.min = num; else price.max = num;
      } else if (n.indexOf('filter.v.option.') === 0) {
        f.push({ variantOption: { name: optName(n), value: v } });
      } else if (n.indexOf('filter.p.m.') === 0) {
        var rest = n.slice(11), d = rest.indexOf('.');
        if (d < 1) return null;
        f.push({ productMetafield: { namespace: rest.slice(0, d), key: rest.slice(d + 1), value: v } });
      } else if (n === 'filter.p.tag') {
        f.push({ tag: v });
      } else {
        return null;
      }
    }
    if (price) f.push({ price: price });
    return f;
  }

  /* ---------- sayimlar ---------- */
  function localCounts(pairs, g, s) {
    var sel = g === 't' ? s.vendors : s.types, set = null, out = Object.create(null), i, ix = s.avail ? 3 : 2;
    if (sel.length) { set = Object.create(null); for (i = 0; i < sel.length; i++) set[sel[i]] = 1; }
    for (i = 0; i < pairs.length; i++) {
      var p = pairs[i], key = g === 't' ? p[0] : p[1], other = g === 't' ? p[1] : p[0];
      if (!key) continue;
      if (set && !set[other]) continue;
      if (p[ix] > 0) out[key] = (out[key] || 0) + p[ix];
    }
    return out;
  }
  function sumBy(pairs, g, s) {
    var out = Object.create(null), ix = s.avail ? 3 : 2;
    for (var i = 0; i < pairs.length; i++) {
      var key = g === 't' ? pairs[i][0] : pairs[i][1];
      if (key && pairs[i][ix] > 0) out[key] = (out[key] || 0) + pairs[i][ix];
    }
    return out;
  }

  /* Baska filtre (beden, renk, fiyat...) aciksa: o filtrelerle urunleri API'den cek (kendi grubu haric).
     Sonuc gelene kadar liste soluk ve tiklanamaz durumda kalir (yanlis secenek acilmasin diye). */
  function oracleFor(g, s) {
    var f = toFilters(s, g);
    if (!f) return null;
    var key = JSON.stringify(f);
    var o = oracle[key];
    if (o) return o;
    var keys = Object.keys(oracle);
    if (keys.length > 40) {
      for (var j = 0; j < keys.length; j++) if (oracle[keys[j]].status !== 'loading') { delete oracle[keys[j]]; break; }
    }
    var ctl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    o = oracle[key] = { status: 'loading', pairs: null, g: g, ctl: ctl };
    Object.keys(oracle).forEach(function (k) {   /* ayni grubun eski (artik gereksiz) sorgusunu iptal et */
      var x = oracle[k];
      if (k !== key && x.status === 'loading' && x.g === g && x.ctl) { try { x.ctl.abort(); } catch (e) {} }
    });
    fetchPairs(f, ctl ? ctl.signal : undefined).then(function (res) {
      if (res.partial || res.total === 0) { o.status = 'fail'; return; }   /* guvenilir degil: sunucunun listesinde kal */
      o.status = 'done'; o.pairs = res.pairs;
    }).catch(function (err) {
      if (err && err.name === 'AbortError') { if (oracle[key] === o) delete oracle[key]; }
      else { o.status = 'fail'; }
    }).then(function () { refreshAll(); });
    return o;
  }
  function groupsOf() {
    var out = [], all = document.querySelectorAll('.filter-group');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('input[name="' + PT + '"], input[name="' + PV + '"]')) out.push(all[i]);
    }
    return out;
  }
  function refreshAll() {
    var s = readState();
    if (!s) return;
    var gs = groupsOf();
    for (var i = 0; i < gs.length; i++) renderGroup(gs[i], true, s);
  }

  /* ---------- cizim ---------- */
  function build(box, param, items, activeList) {
    var tickEl = box.querySelector('.filter-tick');
    if (tickEl) tickHTML = tickEl.outerHTML;
    else if (!tickHTML) {
      var any = document.querySelector('.filter-group .filter-tick');
      if (any) tickHTML = any.outerHTML;
    }
    var active = Object.create(null);
    activeList.forEach(function (a) { active[a] = 1; });
    var frag = document.createDocumentFragment();
    items.forEach(function (label) {
      var isActive = !!active[label];
      var el = document.createElement('label');
      el.className = 'filter-group__item' + (isActive ? ' filter-group__item--active' : '');
      el.setAttribute('data-tag', slug(label));
      var inp = document.createElement('input');
      inp.className = 'filter-group__checkbox';
      inp.type = 'checkbox';
      inp.name = param;
      inp.value = label;
      inp.id = 'Filter-' + param + '-' + slug(label);
      if (isActive) inp.checked = true;
      var span = document.createElement('span');
      span.className = 'filter-group__item__text';
      span.appendChild(document.createTextNode(label));
      if (tickHTML) span.insertAdjacentHTML('beforeend', tickHTML);
      el.appendChild(inp);
      el.appendChild(span);
      frag.appendChild(el);
    });
    box.textContent = '';
    box.appendChild(frag);
    box.classList.toggle('mx-cf-scroll', items.length > 12);
  }

  function unbusy(g) {
    if (g.classList.contains('mx-cf-busy')) { g.classList.remove('mx-cf-busy'); g.removeAttribute('aria-busy'); }
  }
  function renderGroup(g, force, s) {
    if (!DATA || disabled) return;
    var input = g.querySelector('input[name="' + PT + '"], input[name="' + PV + '"]');
    if (!input) return;
    var box = g.querySelector('.toggle-target-container');
    if (!box) return;
    var param = input.name, gk = param === PT ? 't' : 'v';
    var fresh = !g.hasAttribute('data-mx-sig');          /* temanin yeni basdigi (sunucudan gelen) kutu */
    if (fresh) {
      g._mxNative = [].map.call(box.querySelectorAll('input[name="' + param + '"]'), function (i) { return i.value; });
    }
    s = s || readState();
    if (!s) return;
    var sig = stateKey(s) + '|' + ver;
    if (!force && g.getAttribute('data-mx-sig') === sig) return;

    var counts, o;
    if (s.other.length === 0) {
      counts = localCounts(DATA.pairs, gk, s);
    } else {
      o = oracleFor(gk, s);
      if (o && o.status === 'loading') {       /* sonuc gelene kadar bekle: liste soluk, tiklanamaz */
        g.setAttribute('data-mx-sig', sig);
        g.classList.add('mx-cf-busy'); g.setAttribute('aria-busy', 'true');
        return;
      }
      if (o && o.status === 'done') {
        counts = sumBy(o.pairs, gk, s);
      } else if (fresh) {                      /* hesaplanamadi: sunucunun kendi (dogru ama eksik olabilen) listesi */
        counts = Object.create(null);
        (g._mxNative || []).forEach(function (v) { counts[v] = 1; });
      } else {
        g.setAttribute('data-mx-sig', sig); unbusy(g);
        return;
      }
    }
    var active = gk === 't' ? s.types : s.vendors;
    var items = Object.keys(counts);
    active.forEach(function (a) { if (items.indexOf(a) < 0) items.push(a); });
    items.sort(function (a, b) { return a.localeCompare(b, 'tr'); });

    g.setAttribute('data-mx-sig', sig);
    unbusy(g);
    if (!items.length) { g.style.display = 'none'; g._mxCsig = null; return; }
    g.style.display = '';
    var csig = items.join('\u0001') + '\u0002' + active.join('\u0001');
    if (!fresh && g._mxCsig === csig && box.firstChild) return;   /* ayni icerik: yeniden cizme */
    g._mxCsig = csig;
    build(box, param, items, active);
  }

  function apply() {
    if (!DATA || disabled) return;
    var s = readState();
    var groups = document.querySelectorAll('.filter-group');
    for (var i = 0; i < groups.length; i++) renderGroup(groups[i], false, s);
    checkEmpty();
  }

  /* Bir filtre degisince etkilenen listeyi hemen guncelle (sunucu cevabini beklemeden).
     Baska filtre aciksa liste, sonuc gelene kadar soluk/tiklanamaz olur. */
  function narrowAfter(changedName) {
    if (!DATA || disabled) return;
    var s = readState();
    if (!s) return;
    var gs = groupsOf();
    for (var i = 0; i < gs.length; i++) {
      var inp = gs[i].querySelector('input[name="' + PT + '"], input[name="' + PV + '"]');
      if (inp && inp.name !== changedName) renderGroup(gs[i], true, s);   /* kendi grubu degismez (ayni grupta VEYA mantigi) */
    }
  }

  /* ---------- guvenlik agi: sonuc bossa son secimi geri al ---------- */
  function toast(msg) {
    var t = document.querySelector('.mx-cf-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mx-cf-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.style.display = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.display = 'none'; }, 5000);
  }
  /* ilgili filtre degeri adres cubugundan cikarilmis (ya da geri eklenmis) yeni adres */
  function revertUrl(a) {
    var u = new URLSearchParams(location.search);
    var vals = u.getAll(a.name).filter(function (x) { return x !== a.value; });
    u.delete(a.name);
    if (!a.text && !a.checked) vals.push(a.value);       /* kullanici bir secimi kaldirmisti: geri ekle */
    vals.forEach(function (x) { u.append(a.name, x); });
    u.delete('page');
    var q = u.toString();
    return location.pathname + (q ? '?' + q : '');
  }
  function gridSnap() {
    var el = document.querySelector('.filters-adjacent') || document.querySelector('[data-ajax-container] product-block');
    return { el: el, kid: el && el.firstElementChild };
  }
  function checkEmpty() {
    var a = lastAction;
    if (!a) return;
    if (Date.now() - a.ts > 20000) { lastAction = null; return; }
    var g = gridSnap();
    if (g.el === a.grid.el && g.kid === a.grid.kid) return;          /* sunucu cevabi henuz gelmedi */
    if (document.querySelectorAll('product-block').length) { lastAction = null; return; }   /* urun var: sorun yok */
    if (!/[?&]filter\./.test(location.search)) return;
    lastAction = null;
    var msg = 'Bu seçimle ürün bulunamadı, son seçiminiz geri alındı.';
    var target = null;
    if (!a.text) {
      var inputs = document.querySelectorAll('#CollectionFilterForm input[name="' + a.name + '"]');
      for (var i = 0; i < inputs.length; i++) if (inputs[i].value === a.value) target = inputs[i];
    }
    if (target && target.checked === a.checked) {
      reverting = true;
      target.checked = !a.checked;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      reverting = false;
      toast(msg);
    } else {                                                          /* kutu artik sayfada yok: adresi duzeltip yenile */
      try { sessionStorage.setItem('mxcf_toast', msg); } catch (e) {}
      location.assign(revertUrl(a));
    }
  }

  /* secilince aninda gorsel geri bildirim + daralma (asil filtreleme temanin kendi kodu) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || String(t.name).indexOf('filter.') !== 0) return;
    if (!((t.closest && t.closest('#CollectionFilterForm')) || (t.form && t.form.id === 'CollectionFilterForm'))) return;
    if (t.type === 'checkbox' && t.classList && t.classList.contains('filter-group__checkbox')) {
      if (t.parentNode) t.parentNode.classList.toggle('filter-group__item--active', t.checked);
      if (!reverting) lastAction = { name: t.name, value: t.value, checked: t.checked, ts: Date.now(), grid: gridSnap() };
    } else if ((t.type === 'text' || t.type === 'number') && t.value && !reverting) {
      lastAction = { name: t.name, value: t.value, text: true, ts: Date.now(), grid: gridSnap() };
    }
    narrowAfter(t.name);
  }, true);

  /* tema filtre kutusunu AJAX ile yenileyince listeyi yeniden uygula */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; apply(); });
  }
  function startObserver() {
    var root = document.querySelector('filter-container') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  /* ---------- baslat ---------- */
  function init() {
    startObserver();
    try {
      var pm = sessionStorage.getItem('mxcf_toast');
      if (pm) { sessionStorage.removeItem('mxcf_toast'); toast(pm); }
    } catch (e) {}
    var c = readCache();
    if (c) {
      DATA = c; ver++; apply();
      if (Date.now() - c.ts > REFRESH_AFTER) load();
    } else {
      load();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
